import { useTranslation } from 'react-i18next';
import { Loader } from 'components/Loader';
import { Heading } from 'components/Typography';
import { withScreenerMachineState } from 'domains/signup/screener/context/screenerContext';

const LoadingScreener: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Heading level="h2" className="mb-64">
        {t('screener.steps.loadingScreener.title')}
      </Heading>
      <Loader className="flex justify-center p-24 text-primary-500" />
    </>
  );
};

export const ScreenerLoadingScreener = withScreenerMachineState(LoadingScreener, 'loadingScreener');
